<div class="min-h-screen bg-gradient-to-br p-6">
  <!-- Use the shared navbar component -->

  <!-- Main Content -->

  <div class="container mx-auto px-4">
    <div class="text-center my-8">
      <app-page-title [titleKey]="'cahier.title'"></app-page-title>
    </div>
    <app-loader [isLoading]="isLoading"></app-loader>
    <!-- Use the shared children selector component -->
    <app-children-selector
      [autoSelectFirst]="true"
      (studentSelected)="onStudentSelected($event)"
      (studentsLoaded)="onStudentsLoaded($event)"
    >
    </app-children-selector>
    <!-- Documents Grid -->
    <div
      class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12 mx-8 self-start items-start"
    >
      <div
        *ngFor="let item of paginatedCahierList; trackBy: trackByItemId"
        class="shadow-lg rounded-xl p-4 relative h-fit"
        [ngClass]="item.backgroundClass || 'bg-white'"
      >
        <!-- New Badge -->
        <div
          *ngIf="item.isNew"
          class="absolute -top-3 -right-3 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full shadow-md"
        >
          {{ "cahier.new" | translate }}
        </div>

        <!-- Header row -->
        <div class="flex justify-between items-center">
          <div class="flex flex-col">
            <div>
              <span
                class="font-bold"
                [ngStyle]="{ color: getItemColor(item) }"
                >{{ "cahier.subject" | translate }}</span
              >
              <span class="ml-1">{{ item.matiere }}</span>
            </div>
            <div class="text-gray-500 text-sm mt-1">
              {{ item.displayDate || item.creationDate }}
            </div>
            <div class="text-gray-500 text-sm">
              <span *ngIf="item.typeLabel">{{ item.typeLabel }}</span>
            </div>
          </div>

          <button
            (click)="expandAndMarkSeen(item)"
            class="bg-white rounded-full shadow-lg p-2 hover:bg-gray-50 transition"
            [ngStyle]="{ 'box-shadow': '0 0 10px 3px ' + getItemColor(item) }"
          >
            <svg
              *ngIf="!item.isExpanded"
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5 text-[#009688]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
            <svg
              *ngIf="item.isExpanded"
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5 text-[#009688]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 15l7-7 7 7"
              />
            </svg>
          </button>
        </div>

        <!-- Expanded details -->
        <div *ngIf="item.isExpanded" class="mt-4 border-t pt-4">
          <div *ngIf="item.isDetailsLoading" class="text-sm text-gray-500">
            Chargement...
          </div>

          <div *ngIf="!item.isDetailsLoading">
            <div class="mt-1">
              <span class="font-bold text-[#009688]">Titre</span>
              <span class="ml-1">{{ item.detailTitle || item.name }}</span>
            </div>

            <div class="mt-1">
              <span class="font-bold text-[#009688]">Enseignant</span>
              <span class="ml-1">
                {{ item.detailTeacherName || "-" }}
              </span>
            </div>

            <div class="mt-1">
              <span class="font-bold text-[#009688]">Date de correction</span>
              <span class="ml-1">
                {{ item.detailCorrectionDate || item.atomaticDate }}
              </span>
            </div>

            <div class="mt-1">
              <span class="font-bold text-[#009688]">Description</span>
              <span class="ml-1">
                {{ item.detailDescription || "-" }}
              </span>
            </div>

            <div *ngIf="item.detailFiles?.length">
              <div
                *ngFor="let file of item.detailFiles; let i = index"
                class="mt-1 flex items-center justify-between"
              >
                <span class="font-bold text-[#009688]">
                  Fichier {{ i + 1 }}
                </span>

                <button
                  type="button"
                  class="inline-flex items-center justify-center w-8 h-8 rounded-full border border-[#009688] text-[#009688] hover:bg-[#009688] hover:text-white transition-colors"
                  (click)="downloadHomeworkFile(file)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M12 3v12" />
                    <path d="M8 11l4 4 4-4" />
                    <path d="M4 19h16" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="flex justify-center items-center space-x-1 mt-8">
      <!-- Left Arrow Button -->
      <button
        (click)="previousPage()"
        [disabled]="currentPage === 1"
        class="w-10 h-10 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-teal-50"
      >
        <svg
          class="w-5 h-5 text-teal-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          ></path>
        </svg>
      </button>

      <!-- Page Numbers -->
      <ng-container *ngFor="let page of getVisiblePages()">
        <!-- Ellipsis -->
        <span
          *ngIf="page === '...'"
          class="w-10 h-10 flex items-center justify-center text-gray-500"
        >
          {{ "common.ellipsis" | translate }}
        </span>

        <!-- Page Number -->
        <button
          *ngIf="page !== '...'"
          (click)="goToPage(+page)"
          [class]="
            currentPage === +page
              ? 'w-10 h-10 flex items-center justify-center rounded-md bg-[#009688] text-white font-bold border border-[#009688]'
              : 'w-10 h-10 flex items-center justify-center rounded-md bg-white text-black border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-colors'
          "
        >
          {{ page }}
        </button>
      </ng-container>

      <!-- Right Arrow Button -->
      <button
        (click)="nextPage()"
        [disabled]="currentPage === totalPages"
        class="w-10 h-10 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-teal-50"
      >
        <svg
          class="w-5 h-5 text-teal-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          ></path>
        </svg>
      </button>
    </div>
  </div>
</div>
